import {postRequest,getRequest,putRequest} from '../../Axios'
import {GET_ALL_CONTAB_TITLE,SET_SEARCH_CONTAB_TITLE,SELECT_FILTER_OPTION_CONTAB_TITLE,FILTER_CONTAB_TITLE,SET_ADD_CONTAB_TITLE_MODAL_OPEN,
        SET_ADD_CONTAB_TITLE_MODAL_CLOSE,TOOGLE_DRAWER_CONTAB_TITLE} from '../../../../constants/ActionTypes'

    export  const addContabTitle=(params,body,CallBack)=>(dispatch)=>{
        dispatch(postRequest("/ContabTitle",params,body))
        .then(resp=>{
            const {payload:{data,status}}=resp;
            CallBack(data,status)
        }).catch(error=>console.log(error));
    }   

    export  const updateContabTitle=({Id},body,CallBack)=>(dispatch)=>{
    dispatch(putRequest(`/ContabTitle/${Id}`,{},{ ...body,Id}))
    .then(resp=>{
        const {payload:{data,status}}=resp;
        CallBack(data,status)
    }).catch(error=>console.log(error));
    }

    export const GetContabTitle=()=>(dispatch)=>{
        dispatch(getRequest("/ContabTitle/GetAllContabTitle",{}))
        .then(resp=>{
            const {payload:{data}}=resp;
            dispatch({
                type:GET_ALL_CONTAB_TITLE,
                payload:data
            })
        }).catch(error=>console.log(error));
    }

    export const setSearchContabTitle=(seachText)=>{
        return{
            type:SET_SEARCH_CONTAB_TITLE,
            payload:seachText
        }
    }

    export const selectOptionContabTitle=(optionId)=>{  

        return{
            type:SELECT_FILTER_OPTION_CONTAB_TITLE,
            payload:optionId
        }
    }

    export const filterContabTitle=()=>{
        return {
            type:FILTER_CONTAB_TITLE
        }
    }

    export const addContabTitleModalOpen =()=>({
        type:SET_ADD_CONTAB_TITLE_MODAL_OPEN,
        payload:true
    })

    export const addContabTitleModalClose =()=>({
            type:SET_ADD_CONTAB_TITLE_MODAL_CLOSE,
            payload:false
    })

export const toogleDrawerContabTitle=()=>({
    type:TOOGLE_DRAWER_CONTAB_TITLE
})
  
